import { Bounce, toast } from 'react-toastify';
import ReactHtmlParser from 'react-html-parser';

export enum TOASTIFY_TYPES {
  INFO = 'info',
  SUCCESS = 'success',
  WARNING = 'warning',
  ERROR = 'error',
  DEFAULT = 'default',
}

// TODO This is not working yet to be fixed
const getToastIcon = (type: TOASTIFY_TYPES) => {
  switch (type) {
    case TOASTIFY_TYPES.SUCCESS:
      return '<i className="fa-regular fa-indian-rupee-sign" />';
    case TOASTIFY_TYPES.ERROR:
      return '<i className="fa-regular fa-indian-rupee-sign" />';
    case TOASTIFY_TYPES.WARNING:
      return '<i className="fa-regular fa-triangle-exclamation" />';
    case TOASTIFY_TYPES.INFO:
      return '<i className="fa-regular fa-circle-info" />';
    default:
      return '';
  }
};

export const reactToastify = (message: string, type: TOASTIFY_TYPES = TOASTIFY_TYPES.INFO, options = {}) => {
  toast(message, {
    position: 'top-right',
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: false,
    pauseOnHover: true,
    draggable: true,
    theme: 'light',
    transition: Bounce,
    type,
    icon: ReactHtmlParser(getToastIcon(type)),
    ...options,
  });
};
